/* Hover panel on the product card: pick grind and size without opening the
   product page. Modelled on the Purely "Bean" card.

   The theme already renders one <select> per option inside <variant-selects>,
   and its own JS listens to those selects to swap the variant and the price.
   So the selects stay exactly where they are (visually hidden) and the pills
   drive them: a click sets .value and dispatches a real 'change' event, which
   the theme handles as if a human used the dropdown. Nothing about the
   variant logic is reimplemented here. */
(function () {
  var BUILT = 'data-cappa-quickpick';

  function optionName(select) {
    var m = (select.getAttribute('name') || '').match(/options\[(.+)\]/);
    return m ? m[1] : '';
  }

  /* Homepage (27 Sep 2026): each option is one compact dropdown ("Size: 250g")
     instead of a row of pills, and every card, with or without options, gets
     the same bottom block, so price, options and button line up across a row. */
  /* More Products preview (29 Sep 2026): the dropdown card is used on every page, not just
     the homepage, so collection, search and related-product cards match. */
  var HOME = true;

  function build(card) {
    if (card.hasAttribute(BUILT)) return;
    var vs = card.querySelector('variant-selects');
    var selects = vs ? vs.querySelectorAll('select') : [];
    if (!selects.length) {
      if (HOME) {
        var holder = document.createElement('div');
        holder.className = 'card-quickpick card-quickpick--empty';
        var f = card.querySelector('product-form') || card.querySelector('.cappa-choose');
        if (f) holder.appendChild(f);
        card.appendChild(holder);
        card.setAttribute(BUILT, '');
      }
      return;
    }

    var panel = document.createElement('div');
    panel.className = 'card-quickpick';

    Array.prototype.forEach.call(selects, function (select) {
      var name = optionName(select);
      if (!name) return;
      var group = document.createElement('div');
      group.className = 'card-quickpick__group';

      if (HOME) {
        var dd = document.createElement('select');
        dd.className = 'card-quickpick__select';
        dd.setAttribute('aria-label', name);
        Array.prototype.forEach.call(select.options, function (opt) {
          var o = document.createElement('option');
          o.value = opt.value;
          o.textContent = name + ': ' + opt.textContent.trim().replace(/^[^:]+:\s*/, '');
          if (opt.selected) o.selected = true;
          dd.appendChild(o);
        });
        group.appendChild(dd);
        panel.appendChild(group);
        return;
      }

      var label = document.createElement('span');
      label.className = 'card-quickpick__label';
      label.textContent = name;
      group.appendChild(label);

      var row = document.createElement('div');
      row.className = 'card-quickpick__pills';

      Array.prototype.forEach.call(select.options, function (opt) {
        var pill = document.createElement('button');
        pill.type = 'button';
        pill.className = 'card-quickpick__pill';
        /* "Ground: Espresso - Home" is the full option value; the pill only
           needs the part after the colon or the panel runs off the card. */
        pill.textContent = opt.textContent.trim().replace(/^[^:]+:\s*/, '');
        pill.title = opt.textContent.trim();
        pill.setAttribute('aria-pressed', opt.selected ? 'true' : 'false');
        if (opt.selected) pill.classList.add('is-on');
        pill.setAttribute('data-name', name);
        pill.setAttribute('data-value', opt.value);
        row.appendChild(pill);
      });

      group.appendChild(row);
      panel.appendChild(group);
    });

    if (!panel.children.length) return;

    /* Move the card's own add-to-cart button into the panel so the whole
       choose-and-add flow lives in one place, the way the reference does. */
    var form = card.querySelector('product-form');
    if (form) panel.appendChild(form);

    /* The panel goes at the end of the card, after the picture and the title,
       not on top of the photograph. Overlaying it covered the product, sat
       under the wishlist icons and could not be made to behave on a phone,
       where there is no hover to reveal or hide it. */
    card.appendChild(panel);
    card.setAttribute(BUILT, '');
  }

  /* ------------------------------------------------------------------
     The theme ships the card's option dropdowns wired to nothing: changing
     one updates neither the price nor input[name=id], so a shopper who picks
     1KG on a collection card adds the 250g variant to their cart. Verified
     against the live theme before touching it, so this is the theme's bug and
     not a side effect of the hover panel. The card already prints the variant
     list as JSON and a full <select> of variants carrying formatted prices,
     so both halves of the fix are already on the page.
     ------------------------------------------------------------------ */
  function variantData(vs) {
    var tag = vs.querySelector('script[type="application/json"]');
    if (!tag) return null;
    try { return JSON.parse(tag.textContent); } catch (e) { return null; }
  }

  function chosen(vs) {
    return Array.prototype.map.call(vs.querySelectorAll('select'), function (s) {
      return s.value;
    });
  }

  function match(variants, picked) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i], ok = true;
      for (var j = 0; j < picked.length; j++) {
        if (v.options[j] !== picked[j]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  function apply(card) {
    var vs = card.querySelector('variant-selects');
    if (!vs) return;
    var variants = variantData(vs);
    if (!variants) return;
    var v = match(variants, chosen(vs));
    if (!v) return;

    var idInput = card.querySelector('input[name="id"]');
    if (idInput) {
      idInput.value = v.id;
      idInput.disabled = false;
    }

    /* The card's hidden variant <select> already holds each price formatted by
       Liquid's money filter, so the shop's own currency format is reused
       rather than guessed at here. */
    var box = card.querySelector('.price');
    var opt = card.querySelector('select.no-js option[value="' + v.id + '"]');
    if (box && opt && opt.dataset.price) {
      /* data-price comes from Liquid's `money` filter, which drops the
         currency code the card normally prints. Remember whatever the card
         rendered first and keep that suffix, so one card does not read
         "$17.50" while its neighbours read "$17.50 AUD". */
      if (box.dataset.cappaSuffix === undefined) {
        var firstEl = box.querySelector('.price-item--regular') || box;
        var first = (firstEl.textContent || '').trim();
        var m = first.match(/[\d.,]+\s*(.*)$/);
        box.dataset.cappaSuffix = m && m[1] ? ' ' + m[1].trim() : '';
      }
      /* Update the two parts separately. Writing the whole box used to wipe the
         compare-at ("was") price the moment a size was picked. */
      var reg = box.querySelector('.price-item--regular');
      var was = box.querySelector('.price-item--sale');
      if (reg) {
        reg.textContent = opt.dataset.price + box.dataset.cappaSuffix;
        if (was) {
          var num = function (s) { return parseFloat(String(s || '').replace(/[^\d.]/g, '')) || 0; };
          was.textContent = num(opt.dataset.cprice) > num(opt.dataset.price)
            ? opt.dataset.cprice + box.dataset.cappaSuffix : '';
        }
      } else {
        box.textContent = opt.dataset.price + box.dataset.cappaSuffix;
      }
    }

    var btn = card.querySelector('.product-form__submit');
    if (btn) {
      btn.disabled = !v.available;
      var span = btn.querySelector('span');
      if (span) span.textContent = v.available ? span.dataset.inStock || span.textContent : 'Sold out';
    }
  }

  function wire(card) {
    var vs = card.querySelector('variant-selects');
    if (!vs || vs.hasAttribute('data-cappa-wired')) return;
    vs.setAttribute('data-cappa-wired', '');
    apply(card);
  }

  /* All listeners are delegated from the document (27 Sep 2026). Slick's
     infinite carousels copy finished cards into .slick-cloned slides; a copy
     keeps the markup and the data-cappa-* markers but none of the listeners,
     so dropdowns on a copied card used to change nothing and Add to Cart sent
     the default 250g. Delegation reaches originals and copies alike. */
  function realSelect(card, name) {
    var list = card.querySelectorAll('variant-selects select');
    for (var i = 0; i < list.length; i++) if (optionName(list[i]) === name) return list[i];
    return null;
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var card = t.closest('.product-card-inner');
    if (!card) return;
    if (t.classList.contains('card-quickpick__select')) {
      var select = realSelect(card, t.getAttribute('aria-label'));
      if (!select) return;
      select.value = t.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    } else if (t.closest('variant-selects')) {
      apply(card);
    }
  });

  document.addEventListener('click', function (e) {
    var pill = e.target && e.target.closest && e.target.closest('.card-quickpick__pill');
    if (!pill) return;
    var card = pill.closest('.product-card-inner');
    var select = card && realSelect(card, pill.getAttribute('data-name'));
    if (!select) return;
    e.preventDefault();
    e.stopPropagation();
    select.value = pill.getAttribute('data-value');
    select.dispatchEvent(new Event('change', { bubbles: true }));
    Array.prototype.forEach.call(pill.parentNode.children, function (p) {
      p.classList.remove('is-on');
      p.setAttribute('aria-pressed', 'false');
    });
    pill.classList.add('is-on');
    pill.setAttribute('aria-pressed', 'true');
  });

  function scan(root) {
    (root || document).querySelectorAll('.product-card-inner').forEach(function (c) {
      build(c);
      wire(c);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }
  /* facets.js re-opens the panels after its own init, so the collapse is run
     again once the page has settled rather than only on DOMContentLoaded. */
  /* Collection filtering and the tabbed home section replace whole grids. */
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      if (muts[i].addedNodes.length) { scan(); return; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
